import Vue from "vue"
import Vuetify from "vuetify/lib"
import it from "vuetify/es5/locale/it"

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#D62436",
        // primary: "#ee44aa",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  lang: {
    locales: { it },
    current: "it",
  },
  icons: {
    iconfont: "fa",
  },
})

// extra plugin

import DatetimePicker from "vuetify-datetime-picker"

Vue.use(DatetimePicker)
